import { combineReducers } from "redux";

import * as filterActions from "./actions/filters";
import * as loadingActions from "./actions/loading";
import * as routerActions from "./actions/router";
import * as slideDeckActions from "./actions/slide_decks";
import { AJAX } from "./actions/ajax";

import { routes } from "./routes";
import { assignSelect, resetSelect, assignMultiSelect, resetMultiSelect } from "../shared/select_and_multi_select_helpers";


const makeMainReducer = () => {
  const resetSelectIfNewSection = (state, action) => (action.sectionChanged ? resetSelect(state) : state);

  const resetMultiSelectIfNewSection = (state, action) => (action.sectionChanged ? resetMultiSelect(state) : state);

  const year = (state = {}, action) => {
    switch(action.type) {
    case filterActions.YEAR_CHANGED:
      return assignSelect(state, action);
    case routerActions.ROUTER_LOCATION_CHANGED:
      return resetSelectIfNewSection(state, action);
    case filterActions.RESET_ALL:
      return resetSelect(state, action);
    default:
      return state;
    }
  };
  const cities = (state = {}, action) => {
    switch(action.type) {
    case filterActions.CITIES_CHANGED:
      return assignMultiSelect(state, action);
    case routerActions.ROUTER_LOCATION_CHANGED:
      return resetMultiSelectIfNewSection(state, action);
    case filterActions.RESET_CITIES:
      return resetMultiSelect(state);
    case filterActions.RESET_ALL:
      return resetMultiSelect(state);
    default:
      return state;
    }
  };
  const countries = (state = {}, action) => {
    switch(action.type) {
    case filterActions.COUNTRIES_CHANGED:
      return assignMultiSelect(state, action);
    case routerActions.ROUTER_LOCATION_CHANGED:
      return resetMultiSelectIfNewSection(state, action);
    default:
      return state;
    }
  };
  const country = (state = {}, action) => {
    switch(action.type) {
    case filterActions.COUNTRY_CHANGED:
      return assignSelect(state, action);
    case routerActions.ROUTER_LOCATION_CHANGED:
      return resetSelectIfNewSection(state, action);
    case filterActions.RESET_ALL:
      return resetSelect(state, action);
    default:
      return state;
    }
  };

  const filters = combineReducers({
    year, cities, countries, country
  });

  const loading = (state = {}, action) => {
    let newState, tempLoadedData;

    switch(action.type) {
    case loadingActions.LOADING_DATA_STARTED:
      tempLoadedData = { mainTableData: null };

      if (action.sectionChanged || (action.sectionSlug === routes.cities.slug && !action.tabChanged)) {
        tempLoadedData.verticalChart = null;
      }

      // if (action.sectionChanged || action.tabChanged || action.sectionSlug !== routes.global.slug || action.tabSlug !== routes.global.tabs.change_map.slug) {
      tempLoadedData.mainChart = null;
      // }

      newState = {
        sectionIsLoading: !!(action.sectionChanged),
        tabIsLoading: !(action.sectionChanged),
        loadedData: Object.assign({}, state.loadedData, tempLoadedData)
      };
      return Object.assign({}, state, newState);
    case loadingActions.DATA_LOADED:
      return Object.assign({}, state, { loadedData: action.data.allData });
    case loadingActions.LOADING_DATA_FINISHED:
      return Object.assign({}, state, { tabIsLoading: false, sectionIsLoading: false });
    default:
      return state;
    }
  };

  const newSlideDeckOption = {
    label: "New slide deck",
    value: slideDeckActions.NEW_VALUE
  };
  const defaultSlideDeckState = {
    slideDeckBeingSaved: false,
    selectedOptionValue: slideDeckActions.NEW_VALUE,
    textValue: "",
    newOption: newSlideDeckOption,
    options: [],
    loadingOptions: true,
    submittingSlide: false,
    chartSvg: false
  };

  const slideDecks = (state = defaultSlideDeckState, action) => {
    switch(action.type) {
    case slideDeckActions.CHART_SLIDE_DECK_BUTTON_CLICKED:
      return Object.assign({}, state, {
        slideDeckBeingSaved: true, chartSvg: action.payload.chartSvg, title: action.payload.title
      });
    case slideDeckActions.SUBMIT_SLIDE_DECK_BUTTON_CLICKED:
      return state;
    case slideDeckActions.SLIDE_DECK_TEXT_CHANGE:
      return Object.assign({}, state, { textValue: action.payload });
    case slideDeckActions.SLIDE_DECK_RADIO_BUTTON_CLICKED:
      return Object.assign({}, state, {
        textValue: "",
        selectedOptionValue: action.payload === slideDeckActions.NEW_VALUE ? action.payload : +action.payload
      });
    case slideDeckActions.SD_OPTIONS_LOADED:
      return Object.assign({}, state, { options: action.data, loadingOptions: false });
    case slideDeckActions.SD_SUBMIT_STARTED:
      return Object.assign({}, state, { submittingSlide: true });
    case slideDeckActions.SD_LOADING_OPTIONS_STARTED:
    case slideDeckActions.SD_LOADING_OPTIONS_FINISHED:
    case slideDeckActions.SD_SUBMITTED:
    case AJAX:
      return state;
    case slideDeckActions.SD_SUBMIT_FINISHED:
    case slideDeckActions.CANCEL_SLIDE_DECK_BUTTON_CLICKED:
    case routerActions.ROUTER_LOCATION_CHANGED:
    case filterActions.RESET_ALL:
    default:
      return defaultSlideDeckState;
    }
  };

  const dataHubSearchObject = (state = {}, action) => {
    switch(action.type) {
    default:
      return state;
    }
  };
  const mainReducer = combineReducers({
    filters, loading, slideDecks, dataHubSearchObject
  });

  return mainReducer;
};

export default makeMainReducer;
